import axios from "axios";
import graph from "../services/graph";

//poziv express-u da dohvati podatke vezane uz osobu
export default {
  getAll(accessToken) {
    try {
      console.log(accessToken);
      return axios.get("https://app-psod.cratis.cloud/cases/sharepoint", {
        params: {
          token: accessToken,
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getById(accessToken, groupId) {
    try {
      return axios.get("https://app-psod.cratis.cloud/cases/sharepoint/" + groupId, {
        params: {
          token: accessToken,
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group by id.");
    }
  },
  getTestPdf(accessToken) {
    console.log("It's here", accessToken)
    try {
      return axios.post("https://app-psod.cratis.cloud/cases/file/ms-pdf", {
        params: {
          token: accessToken,
          groupId: groupId,
          sid : sid,
          path: path,
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group by id.");
    }
  },
  searchDriveItems(accessToken, qString) {
    try {
      return axios.get("https://app-psod.cratis.cloud/cases/sharepoint/search/items" , {
        params: {
          token: accessToken,
          qString
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group by id.");
    }
  },
  getRootDocs(accessToken, groupId) {
    try {
      return axios.get(
        "https://app-psod.cratis.cloud/cases/sharepoint/" + groupId + "/root",
        {
          params: {
            token: accessToken,
          },
          credentials: true,
        }
      );
    } catch {
      console.log("Failed attempt at group by id.");
    }
  },
  getDocumentsInSpis(accessToken, groupId, sid, smjer) {
    try {
      return axios.get(
        "https://app-psod.cratis.cloud/cases/sharepoint/" + groupId + "/" + sid,
        {
          params: {
            token: accessToken,
            smjer

          },
          credentials: true,
        }
      );
    } catch {
      console.log("Failed attempt at group by id.");
    }
  },
  getSingleDoc(accessToken, groupId, sid) {
    try {
      return axios.get(
        "https://app-psod.cratis.cloud/cases/sharepoint/" + groupId + "/item/" + sid,
        {
          params: {
            token: accessToken,
          },
          credentials: true,
        }
      );
    } catch {
      console.log("Failed attempt at group by id.");
    }
  },
  renameSingleDoc(accessToken, groupId, sid,new_name) {
    try {
      return axios.put(
        "https://app-psod.cratis.cloud/cases/sharepoint/" + groupId + "/item/" + sid,
        {
          params: {
            token: accessToken,
            new_name
          },
          credentials: true,
        }
      );
    } catch {
      console.log("Failed attempt at group by id.");
    }
  },
  addDocumentInSpis(formData) {
    try {
      return axios.post("https://app-psod.cratis.cloud/cases/file", formData);
    } catch (err) {
      console.log(err);
    }
  },
  mergeFiles(popis_dl_links, index, file_name){
    try {
      return axios.post(
        "https://app-psod.cratis.cloud/cases/file/merge-pdf",
        {
          params: {
            popis_dl_links,
            index,file_name
          },
          credentials: true,
        },
        
      );
    } catch {
      console.log("Failed to merge documents");
    }
  },
  mergeFilesFinal(index, file_name){
    try {
      return axios({
        method: 'POST',
        url: "https://app-psod.cratis.cloud/cases/file/merge-pdf-final",
        params: {
          index,
          file_name
        },
        responseType:"arraybuffer",
        encodeURI : "UTF-8",
        credentials: true,
      })
    } catch {
      console.log("Failed to merge documents");
    }
  },
  mergeFilesClear(file_name){
    try {
      return axios({
        method: 'POST',
        url: "https://app-psod.cratis.cloud/cases/file/merge-pdf-clear",
        params: {
          file_name
        },
        responseType:"arraybuffer",
        encodeURI : "UTF-8",
        credentials: true,
      })
    } catch {
      console.log("Failed to merge documents");
    }
  },
  createFolderDocs(accessToken, groupId, parent, docname) {
    try {
      return axios.post(
        "https://app-psod.cratis.cloud/cases/sharepoint/" + groupId + "/folder",
        {
          params: {
            token: accessToken,
            groupId: groupId,
            parent: parent,
            docname: docname,
          },
          credentials: true,
        }
      );
    } catch {
      console.log("Failed attempt at group by id.");
    }
  },
  createTemplateDoc(accessToken, groupId, parent,template_name, docname) {
    try {
      return axios.post(
        "https://app-psod.cratis.cloud/cases/file/template",
        {
          params: {
            token: accessToken,
            groupId: groupId,
            parent: parent,
            docname: docname,
            template_name,
            
          },
          credentials: true,
        }
      );
    } catch {
      console.log("Failed attempt at group by id.");
    }
  },
  getTemplateDocs() {
    try {
      return axios.get(
        "https://app-psod.cratis.cloud/cases/file/template",
        {
          
          credentials: true,
        }
      );
    } catch {
      console.log("Failed attempt at group by id.");
    }
  },
  // addNewFolder(accessToken,groupId,parent,docname) {
  //   console.log(accessToken);
  //   console.log(groupId);
  //   console.log(parent);
  //   console.log(docname)
  //   try {
  //     return axios.post("https://app-psod.cratis.cloud/sharepoint/folder",  {
  //       params: {
  //         token: accessToken,
  //         groupId : groupId,
  //         parent : parent,
  //         docname : docname
  //       },
  //       credentials: true,
  //     });
  //   } catch (err) {
  //     console.log(err);
  //   }
  // },
  deleteFile(accessToken, groupId, path) {
    try {
      return axios.delete("https://app-psod.cratis.cloud/cases/file", {
        params: {
          token: accessToken,
          groupId: groupId,
          path: path,
        },
        credentials: true,
      });
    } catch (err) {
      console.log(err);
    }
  },
  copyFile(accessToken, groupId, itemId, driveItem) {
    try {
      return axios.post("https://app-psod.cratis.cloud/cases/copy", {
        params: {
          token: accessToken,
          groupId: groupId,
          itemId: itemId,
          driveItem: driveItem,
        },
        credentials: true,
      });
    } catch (err) {
      console.log(err);
    }
  },
  convertToPDF(accessToken, groupId,sid, path, final_name, extension,logged_uid,spis_name) {
    try {
      return axios.post("https://app-psod.cratis.cloud/cases/file/ms-pdf", {
        params: {
          token: accessToken,
          groupId: groupId,
          sid : sid,
          path: path,
          final_name,
          extension,
          logged_uid,
          spis_name
        },
        credentials: true,
      });
    } catch (err) {
      console.log(err);
    }
  },
  getFileThumbnails(accessToken, groupId,sid, path) {
    try {
      return axios.get("https://app-psod.cratis.cloud/cases/file/thumbnails", {
        params: {
          token: accessToken,
          groupId: groupId,
          sid : sid,
          path: path,
        },
        credentials: true,
      });
    } catch (err) {
      console.log(err);
    }
  },
  moveDriveItem(accessToken, groupId,sid, path,driveItem) {
    try {
      return axios.post("https://app-psod.cratis.cloud/cases/file/move", {
        params: {
          token: accessToken,
          groupId: groupId,
          sid : sid,
          path: path,
          driveItem:driveItem
        },
        credentials: true,
      });
    } catch (err) {
      console.log(err);
    }
  },
  
  addNewGroup(accessToken, slucaj) {
    try {
      return axios.post("https://app-psod.cratis.cloud/cases/sharepoint/", {
        params: {
          token: accessToken,
          slucaj: slucaj,
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group by id.");
    }
  },
};
